const timeTypeList = [
  {
    text: '全部时间',
    value: 'all'
  },
  {
    text: '今天',
    value: 'today'
  },
  {
    text: '昨天',
    value: 'yesterday'
  },
  {
    text: '本周',
    value: 'curWeek'
  },
  {
    text: '本月',
    value: 'curMonth'
  },
  {
    text: '上月',
    value: 'preMonth'
  },
  {
    text: '近30天',
    value: 'recentThirtyDay'
  },
  {
    text: '今年',
    value: 'curYear'
  },
  {
    text: '去年',
    value: 'preYear'
  }
]

export const timeTagList = [
  {
    text: '全部时间',
    value: 'all'
  },
  {
    text: '今天',
    value: 'today'
  },
  {
    text: '昨天',
    value: 'yesterday'
  },
  {
    text: '本周',
    value: 'curWeek'
  },
  {
    text: '上周',
    value: 'preWeek'
  },
  {
    text: '本月',
    value: 'curMonth'
  },
  {
    text: '上月',
    value: 'preMonth'
  },
  {
    text: '今年',
    value: 'curYear'
  },
  {
    text: '去年',
    value: 'preYear'
  },
  {
    text: '近30天',
    value: 'recentThirtyDay'
  },
  {
    text: '近60天',
    value: 'recentSixtyDay'
  },
  {
    text: '自定义',
    value: 'selfTime'
  }
]

export const timeOptions = [
  {
    label: '全部时间',
    value: 'all'
  },
  {
    label: '今天',
    value: 'today'
  },
  {
    label: '昨天',
    value: 'yesterday'
  },
  {
    label: '本周',
    value: 'curWeek'
  },
  {
    label: '本月',
    value: 'curMonth'
  },
  {
    label: '上月',
    value: 'preMonth'
  },
  {
    label: '近30天',
    value: 'recentThirtyDay'
  },
  {
    label: '今年',
    value: 'curYear'
  },
  {
    label: '去年',
    value: 'preYear'
  }
]

export default timeTypeList
